import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import './Admin.css';

const AuditLogs = () => {
  const { auditLogs, user } = useApp();
  const [filterUser, setFilterUser] = useState('');
  const [filterAction, setFilterAction] = useState('');

  if (user?.role !== 'Admin' && user?.role !== 'Clerk') {
    return (
      <div className="admin-container">
        <div className="access-denied">
          <h1>🔐 Access Denied</h1>
          <p>You do not have permission to access this page.</p>
        </div>
      </div>
    );
  }

  const uniqueUsers = [...new Set(auditLogs.map(log => log.user))];
  const uniqueActions = [...new Set(auditLogs.map(log => log.action))];

  const filteredLogs = auditLogs.filter(log => {
    const matchesUser = !filterUser || log.user === filterUser;
    const matchesAction = !filterAction || log.action === filterAction;
    return matchesUser && matchesAction;
  });

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h1>📊 Audit Logs</h1>
        <p>System activity and audit trail</p>
      </div>

      <div className="audit-filters">
        <div className="filter-group">
          <label>Filter by User</label>
          <select
            value={filterUser}
            onChange={(e) => setFilterUser(e.target.value)}
          >
            <option value="">All Users</option>
            {uniqueUsers.map(user => (
              <option key={user} value={user}>{user}</option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>Filter by Action</label>
          <select
            value={filterAction}
            onChange={(e) => setFilterAction(e.target.value)}
          >
            <option value="">All Actions</option>
            {uniqueActions.map(action => (
              <option key={action} value={action}>{action}</option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>&nbsp;</label>
          <button
            onClick={() => {
              setFilterUser('');
              setFilterAction('');
            }}
            className="btn-secondary"
          >
            Clear Filters
          </button>
        </div>
      </div>

      <div className="audit-logs-table-card">
        <h2>Audit Logs ({filteredLogs.length})</h2>
        {filteredLogs.length > 0 ? (
          <div className="table-container">
            <table className="audit-table">
              <thead>
                <tr>
                  <th>Timestamp</th>
                  <th>User</th>
                  <th>Action</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {filteredLogs
                  .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
                  .map(log => (
                    <tr key={log.id}>
                      <td>{new Date(log.timestamp).toLocaleString()}</td>
                      <td><strong>{log.user}</strong></td>
                      <td>
                        <span className="action-badge">{log.action}</span>
                      </td>
                      <td>{log.details}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="empty-state">No audit logs found.</p>
        )}
      </div>
    </div>
  );
};

export default AuditLogs;

